import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OrganizationState {
  currentOrganizationId: string | null;
  setCurrentOrganizationId: (id: string) => void;
  orgIncidentStatus: Record<string, boolean>;
  setOrgIncidentStatus: (orgId: string, hasIncident: boolean) => void;
  onboardingChecklistDismissed: boolean;
  setOnboardingChecklistDismissed: (dismissed: boolean) => void;
}

export const useOrganizationStore = create<OrganizationState>()(
  persist(
    (set) => ({
      currentOrganizationId: null,
      setCurrentOrganizationId: (id) => set({ currentOrganizationId: id }),
      orgIncidentStatus: {},
      setOrgIncidentStatus: (orgId, hasIncident) =>
        set((state) => ({
          orgIncidentStatus: {
            ...state.orgIncidentStatus,
            [orgId]: hasIncident,
          },
        })),
      onboardingChecklistDismissed: false,
      setOnboardingChecklistDismissed: (dismissed) =>
        set({ onboardingChecklistDismissed: dismissed }),
    }),
    { name: "organization-preferences" },
  ),
);
